import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Product } from '../models/products.models';
import { BaseComponent } from '../../_shared/base.component';
import { ProductsService } from '../products.service';
import { MessageService } from '../../layout/message/message.service';
import { Participant } from '../../processing/models/processing.models';
import { ProcessingService } from '../../processing/processing.service';

@Component({
	selector: 'pm-detail',
	templateUrl: './detail.component.html',
	styleUrls: ['./detail.component.css'],
})
export class DetailComponent extends BaseComponent implements OnInit {
	product: Product;
	isEditting: boolean;
	endDateString: { day: number; year: number; month: number };
	Categories: string[];

	constructor(
		private productsService: ProductsService,
		private _activeRoute: ActivatedRoute,
		private processingService: ProcessingService,
		router: Router,
		message: MessageService,
	) {
		super(router, message);
		this.Categories = productsService.getCategories();
	}

	ngOnInit() {
		this._activeRoute.paramMap.subscribe(params => {
			if (params.has('id')) {
				const id = +params.get('id');
				if (id === 0) {
					this.isEditting = true;
					this.product = new Product({
						Id: 0,
						CedrSystem: 'NULL',
						IsClosed: false,
						IsDeleted: false,
						NeedTinyUrl: true,
					});
				} else {
					this.isEditting = false;
					this.productsService.getProductWithParticipants(id).subscribe(rsp => {
						const { Data, Error } = rsp;
						if (Error) {
							this.showErrorMessage('Error', Error);
						} else {
							this.product = new Product(Data);
							const d = this.product.EndDate
								? this.product.EndDate.split('T')[0]
								: null;
							if (d != null && d.length > 1) {
								const splitz = d.split('-');
								this.endDateString = {
									year: +splitz[0],
									month: +splitz[1],
									day: +splitz[2],
								};
							}
							this.product.Participants.sort((x, y) => {
								return x.IsAttending && y.IsAttending
									? 0
									: x.IsAttending && !y.IsAttending
										? -1
										: 1;
							});
						}
					}, this.serverErrorHandler);
				}
			}
		});
	}

	editProduct() {
		this.isEditting = !this.isEditting;
	}

	saveProduct() {
		const validity = this.product.isValid();
		if (validity.HasError) {
			this.showErrorMessage('Error', validity.Message);
		} else {
			this.productsService.saveProduct(this.product).subscribe(rsp => {
				if (rsp.Data != null && rsp.Data.Id != null) {
					if (this.product.Id === 0) {
						this.showSuccessMessage('Success', 'Created Product');
						this._router.navigate([`/products`]);
					} else {
						this.showSuccessMessage('Success', 'Updated Product');
						this.editProduct();
					}
				} else {
					this.showInfoMessage(rsp);
				}
			});
		}
	}

	onDateSelect(event: any) {
		this.product.EndDate = `${event.year}-${event.month}-${event.day}`;
	}

	generateTinyUrl() {
		this.productsService.requestTinyUrl(this.product.Id).subscribe(rsp => {
			const { Error, Data } = rsp;
			if (Error) {
				this.showErrorMessage('Error', Error);
			} else {
				this.product.TinyUrl = Data.TinyUrl;
			}
		});
	}

	cancel() {
		this._router.navigate(['/products']);
	}

	flipAttending(participant: Participant) {
		participant.IsAttending = !participant.IsAttending;
		this.processingService.saveParticipant(participant).subscribe(rsp => {
			const { Error } = rsp;
			if (Error) {
				this.showErrorMessage('Error', Error);
			} else {
				this.showSuccessMessage('Success', 'Updated Participant');
			}
		});
	}

	copyToClipboard() {
		if (
			this.productsService.copyToClipboardUtil(document, this.product.TinyUrl)
		) {
			this.showSuccessMessage('Copied!', this.product.TinyUrl);
		} else {
			this.showErrorMessage('Error', 'No tiny url found');
		}
	}
}
